/* ---- search form ---- */
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.dataset.main === "false") {
    }
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(t => {
        this.onChange(t);
      }, 300).bind(this));
    }
  }
  toggleResetButton() {
    let t = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && t) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !t) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset($) {
    $.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);

/* ---- predictive search ---- */
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    let t = this.getQuery();
    if (!this.searchTerm || !t.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, t);
    this.searchTerm = t;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit($) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      $.preventDefault();
    }
  }
  onFormReset($) {
    super.onFormReset($);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    let t = this.getQuery();
    if (t.length) {
      if (this.searchTerm !== t) {
        this.onChange();
      } else if (this.getAttribute("results") === "true") {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup($) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    $.preventDefault();
    switch ($.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
    }
  }
  onKeydown($) {
    if ($.code === "ArrowUp" || $.code === "ArrowDown") {
      $.preventDefault();
    }
  }
  updateSearchForTerm($, t) {
    let e = this.querySelector("[data-predictive-search-search-for-text]");
    let i = e?.innerText;
    if (i) {
      if (i.match(RegExp($, "g")).length > 1) {
        return;
      }
      let s = i.replace($, t);
      e.innerText = s;
    }
  }
  switchOption($) {
    if (!this.getAttribute("open")) {
      return;
    }
    let x = $ === "up";
    let e = this.querySelector("[aria-selected=\"true\"]");
    let i = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter($ => $.offsetParent !== null);
    let s = 0;
    if (x && !e) {
      return;
    }
    let a = -1;
    let r = 0;
    while (a === -1 && r <= i.length) {
      if (i[r] === e) {
        a = r;
      }
      r++;
    }
    this.statusElement.textContent = "";
    if (!x && e) {
      s = a === i.length - 1 ? 0 : a + 1;
    } else if (x) {
      s = a === 0 ? i.length - 1 : a - 1;
    }
    if (s === a) {
      return;
    }
    let n = i[s];
    n.setAttribute("aria-selected", true);
    if (e) {
      e.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", n.id);
  }
  selectOption() {
    let t = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (t) {
      t.click();
    }
  }
  getSearchResults($) {
    let x = $.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[x]) {
      this.renderSearchResults(this.cachedResults[x]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent($) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then($ => {
      if (!$.ok) {
        var e = Error($.status);
        this.close();
        throw e;
      }
      return $.text();
    }).then($ => {
      let i = new DOMParser().parseFromString($, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach($ => {
        $.cachedResults[x] = i;
      });
      this.renderSearchResults(i);
    }).catch($ => {
      if ($?.code !== 20) {
        this.close();
        throw $;
      }
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText($) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = $;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults($) {
    this.predictiveSearchResults.innerHTML = $;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close($ = false) {
    this.closeResults($);
    this.isOpen = false;
  }
  closeResults($ = false) {
    if ($) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    let x = this.querySelector("[aria-selected=\"true\"]");
    if (x) {
      x.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
